import React, { useContext } from 'react';
import { QuizContext } from "./ConfigurableQuizContainer";
import ElementHTML from "./QuizElementHTML";
import styled from "@emotion/styled";
import tracking from '../../../utils/tracking';

export default function Results() {

  const { getResults, accruedCards, finalScoreCalculations } = useContext(QuizContext);
  const resultParams = `?s=${finalScoreCalculations()}&a=${finalScoreCalculations("classes").join(",")}`;
  const completedTracking = finalScoreCalculations("trackingInfo");

  window.shareURL = `#/share${resultParams}`;
  window.shareObject = completedTracking;
  window.shareFormatted = finalScoreCalculations("formatted");

  if (accruedCards.length) {
    tracking.trackEvent('clicked', {
      eventComponent: 'completedQuiz',
      quizFinalScore: finalScoreCalculations(),
      quizResultsSummary: getResults(true),
      quizCompletedAnswers: completedTracking
    });
  }

  return (
    <ResultsContainer>
      <ElementHTML content={getResults()} />
    </ResultsContainer>
  )
}

const ResultsContainer = styled.div`
  *[class*="c-"],
  *[class*="score-min-"],
  *[class*="score-max-"] {
    display: none;

    &.force-show {
      display: block !important;
    }
  }

  li {
    &[class*="c-"],
    &[class*="score-min-"],
    &[class*="score-max-"] {
      &.force-show {
        display: list-item !important;
      }
    }

  }


`
